"use client";

import { useState } from "react";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Pagination, PaginationContent, PaginationItem } from "@/components/ui/pagination";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const filters = ["ALL", "CONSTRUCTION", "TECHNOLOGY", "INFRASTRUCTURE", "INTEGRATION"];
const projects = [{
  number: "02",
  name: "Smart Office Hub",
  location: "BROOKLYN, NY",
  category: "TECHNOLOGY",
  span: "md:col-span-2 md:row-span-1",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699819/img/nyla_smart_office.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699819/img/nyla_smart_office.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699819/img/nyla_smart_office.png-wvc-sizes",
  alt: "Integrated smart office technology"
}, {
  number: "04",
  name: "Data Center Core",
  location: "BOSTON, MA",
  category: "TECHNOLOGY",
  span: "md:col-span-1 md:row-span-1",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699819/img/nyla_data_center.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699819/img/nyla_data_center.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699819/img/nyla_data_center.webp-wvc-sizes",
  alt: "High-tech data center facility"
}, {
  number: "05",
  name: "Retail POS Network",
  location: "CHICAGO, IL",
  category: "INTEGRATION",
  span: "md:col-span-1 md:row-span-1",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699819/img/nyla_retail_pos.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699819/img/nyla_retail_pos.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699819/img/nyla_retail_pos.webp-wvc-sizes",
  alt: "Retail point of sale integration"
}, {
  number: "06",
  name: "Corporate Campus",
  location: "MIAMI, FL",
  category: "CONSTRUCTION",
  span: "md:col-span-2 md:row-span-1",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699819/img/nyla_corporate_campus.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699819/img/nyla_corporate_campus.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699819/img/nyla_corporate_campus.png-wvc-sizes",
  alt: "Large scale corporate campus build"
}, {
  number: "07",
  name: "Cloud Migration",
  location: "LOS ANGELES, CA",
  category: "TECHNOLOGY",
  span: "md:col-span-1 md:row-span-1",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699819/img/nyla_cloud_migration.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699819/img/nyla_cloud_migration.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699819/img/nyla_cloud_migration.webp-wvc-sizes",
  alt: "Cloud infrastructure migration"
}, {
  number: "08",
  name: "Industrial Complex",
  location: "SAN FRANCISCO, CA",
  category: "CONSTRUCTION",
  span: "md:col-span-2 md:row-span-2",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699819/img/nyla_industrial_complex.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699819/img/nyla_industrial_complex.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699819/img/nyla_industrial_complex.png-wvc-sizes",
  alt: "Industrial facility construction"
}, {
  number: "09",
  name: "Security Systems",
  location: "AUSTIN, TX",
  category: "INTEGRATION",
  span: "md:col-span-1 md:row-span-1",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699819/img/nyla_security_systems.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699819/img/nyla_security_systems.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699819/img/nyla_security_systems.png-wvc-sizes",
  alt: "Integrated security solutions"
}, {
  number: "11",
  name: "Smart Grid Build",
  location: "PORTLAND, OR",
  category: "INFRASTRUCTURE",
  span: "md:col-span-2 md:row-span-1",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699819/img/nyla_smart_grid.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699819/img/nyla_smart_grid.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699819/img/nyla_smart_grid.png-wvc-sizes",
  alt: "Smart grid infrastructure"
}, {
  number: "12",
  name: "Enterprise Software",
  location: "DENVER, CO",
  category: "TECHNOLOGY",
  span: "md:col-span-2 md:row-span-1",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699819/img/nyla_enterprise_software.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699819/img/nyla_enterprise_software.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699819/img/nyla_enterprise_software.webp-wvc-sizes",
  alt: "Enterprise software deployment"
}];
const pages = [1, 2, 3, 4];
export default function FeaturedProjects() {
  const [activeFilter, setActiveFilter] = useState("ALL");
  const [activePage, setActivePage] = useState(1);
  const intro = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const grid = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.05
  });
  const visibleProjects = activeFilter === "ALL" ? projects : projects.filter(p => p.category === activeFilter);
  return <section data-section-id="3521" id="featured-projects" className="bg-background text-foreground relative overflow-hidden py-20 md:py-32 light">
      <div ref={intro.ref} className={`container mx-auto px-6 md:px-10 transition-all duration-1000 ease-out ${intro.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start min-h-[60vh] lg:min-h-[80vh]">
          <div className="lg:col-span-7 flex flex-col justify-between h-full">
            <div className="flex items-start gap-6">
              <span className="font-mono text-[11px] tracking-[0.2em] uppercase text-primary writing-mode-vertical" style={{
              writingMode: "vertical-rl",
              transform: "rotate(180deg)"
            }}>
                PORTFOLIO / 2014 — 2025
              </span>
              <h1 className="font-default font-extrabold uppercase leading-[0.85] tracking-[-0.04em] text-foreground text-[18vw] md:text-[14vw] lg:text-[9rem] xl:text-[10rem]">FEATURED<br />PROJECTS</h1>
            </div>
          </div>

          <div className="lg:col-span-5 flex flex-col justify-end gap-10 h-full">
            <p className="font-default text-lg md:text-xl leading-relaxed text-muted-foreground max-w-[480px]">
              From code to concrete, we deliver excellence. Explore our portfolio of construction and technology solutions that power modern businesses and build the future of infrastructure.
            </p>

            <div className="hidden md:flex flex-wrap gap-3">
              {filters.map((filter, i) => <Button key={filter} data-index={i} onClick={() => setActiveFilter(filter)} variant="ghost" className={`h-10 px-5 font-default font-bold text-xs uppercase tracking-[0.15em] border transition-all duration-300 ${activeFilter === filter ? "bg-primary text-primary-foreground border-primary hover:bg-primary hover:text-primary-foreground" : "bg-card text-foreground border-border hover:bg-accent hover:text-accent-foreground"}`}>
                  {filter}
                </Button>)}
            </div>

            <div className="md:hidden -mx-6">
              <ScrollArea className="w-full whitespace-nowrap">
                <div className="flex gap-3 px-6 pb-3">
                  {filters.map((filter, i) => <Button key={filter} data-index={i} onClick={() => setActiveFilter(filter)} variant="ghost" className={`h-10 px-5 font-default font-bold text-xs uppercase tracking-[0.15em] border transition-all duration-300 shrink-0 ${activeFilter === filter ? "bg-primary text-primary-foreground border-primary hover:bg-primary hover:text-primary-foreground" : "bg-card text-foreground border-border hover:bg-accent hover:text-accent-foreground"}`}>
                      {filter}
                    </Button>)}
                </div>
                <ScrollBar orientation="horizontal" />
              </ScrollArea>
            </div>
          </div>
        </div>
      </div>

      <div ref={grid.ref} className={`container mx-auto px-6 md:px-10 mt-20 md:mt-32 transition-all duration-1000 ease-out ${grid.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="grid grid-cols-1 md:grid-cols-4 auto-rows-[280px] md:auto-rows-[320px] gap-6">
          {visibleProjects.map((project, i) => <div key={project.number} data-index={i} className={`group relative overflow-hidden cursor-pointer shadow-lg rounded-lg ${project.span}`}>
              <img src={project.image} data-wvc-srcset={project.srcset} data-wvc-sizes={project.sizes} alt={project.alt} loading="lazy" decoding="async" className="absolute inset-0 h-full object-cover transition-all duration-[600ms] ease-out group-hover:scale-[1.04] !w-[318px]" />

              <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-colors duration-500" />

              <div className="absolute top-4 right-4 w-5 h-5 pointer-events-none z-10">
                <span className="absolute top-0 right-0 w-5 h-[1.5px] bg-primary" />
                <span className="absolute top-0 right-0 w-[1.5px] h-5 bg-primary" />
              </div>

              <div className="absolute left-0 right-0 bottom-0 bg-card/90 backdrop-blur-sm text-foreground translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out px-5 py-4">
                <div className="flex items-baseline justify-between gap-4">
                  <div className="flex items-baseline gap-3 min-w-0">
                    <span className="font-mono font-bold text-xs shrink-0 text-primary">
                      No{project.number}
                    </span>
                    <h3 className="font-default font-bold text-lg md:text-xl truncate">
                      {project.name}
                    </h3>
                  </div>
                  <span className="font-default text-[11px] uppercase tracking-[0.15em] shrink-0 hidden sm:block text-muted-foreground">
                    {project.location}
                  </span>
                </div>
                <span className="font-default text-[11px] uppercase tracking-[0.15em] sm:hidden block mt-1 text-muted-foreground">
                  {project.location}
                </span>
              </div>
            </div>)}
        </div>

        <div className="mt-16 md:mt-24 flex items-center justify-center">
          <Pagination>
            <PaginationContent className="gap-2 md:gap-6">
              <PaginationItem>
                <Button variant="ghost" size="icon" onClick={() => setActivePage(p => Math.max(1, p - 1))} disabled={activePage === 1} className="text-foreground hover:bg-accent hover:text-primary h-10 w-10" aria-label="Previous page">
                  <ArrowLeft className="w-5 h-5" />
                </Button>
              </PaginationItem>

              <div className="flex items-center gap-1 md:gap-2">
                {pages.map((page, i) => <PaginationItem key={page} data-index={i}>
                    <Button variant="ghost" onClick={() => setActivePage(page)} className={`h-10 min-w-10 px-3 font-default font-medium text-[13px] relative transition-colors ${activePage === page ? "text-primary hover:text-primary hover:bg-transparent" : "text-muted-foreground hover:text-foreground hover:bg-transparent"}`}>
                      {String(page).padStart(2, "0")}
                      {activePage === page && <span className="absolute bottom-1 left-3 right-3 h-[2px] bg-primary" />}
                    </Button>
                  </PaginationItem>)}
              </div>

              <PaginationItem>
                <Button variant="ghost" size="icon" onClick={() => setActivePage(p => Math.min(pages.length, p + 1))} disabled={activePage === pages.length} className="text-foreground hover:bg-accent hover:text-primary h-10 w-10" aria-label="Next page">
                  <ArrowRight className="w-5 h-5" />
                </Button>
              </PaginationItem>
            </PaginationContent>
          </Pagination>
        </div>
      </div>
    </section>;
}